<template>
      <div no-body class="lku-benefit"> 
      <b-row>
        <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend><label>Filter</label></b-input-group-prepend>
              <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-2"
          ref="tblBenefit"
          responsive
          striped hover
          :items="items"
          :fields="fields"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          :filter="filter"
          :filterIncludedFields="filterOn"
          @row-clicked="selectItem"
        >
        <template v-slot:cell(index)="data">
          {{ data.index +1}}
        </template>
        </b-table>
  </div>
</template>
<style lang="scss">
  .lku-benefit {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import crud from "../../apis/crud";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
          {
            key: "NmClaim",
            label: "Benefit Name",
            sortable: true
          },
          {
            key: "ResetKali",
            label: "Period New Plafon (in Month)",
            sortable: true
          },
          {
            key: "MaxKali",
            label: "Max. Claim Times per Period Plafon",
            sortable: true
          },
          {
            key: "PaidPerClaim",
            label: "% Penggantian Biaya per Claim",
            sortable: true
          },
      ],
      items:[],
      tblData: {
        tablename:'benefitvw',
        sortBy: null,
        sortDesc: false
      },
      filter:null, filterOn:[]
    };
  },
  created: async function() {
      this.data();
  },
  mounted() {
    // Set the initial number of items
    this.tblData.total = this.items.length;
  },
  methods: {
    // onFiltered(filteredItems) {
    //   this.tblData.total = filteredItems.length;
    //   this.tblData.page = 1;
    // },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.items=await crud.list(this.tblData);
      return this.items;      

    },
    selectItem(item,index) {
        // const idxChg = this.items.findIndex((rec)=>{
        //                 return (rec.kodegroup.startsWith(item.kodegroup) && (rec.kodegroup !==item.kodegroup));
        //             })
        // if ((idxChg || -1) > -1) {
        //   console.log ('Account punya anak tidak boleh dipilih');
        //     toastr.warn('Account punya anak tidak boleh dipilih!');
        // } else {
        this.$emit("click", item);
        // }
    },  
    refresh() {
      this.$refs.tblBenefit.refresh();
    }
  }
};
</script>
